import React, { Component } from 'react';
import { compose, withProps, withStateHandlers } from 'recompose';
import RemoveLastDirectoryPartOf from '../goBackButton';
import MoonLoader from 'react-spinners/MoonLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBus } from '@fortawesome/free-solid-svg-icons';
import { Card } from 'tabler-react';
import Methods from '../../ApiCalls/apiMethods';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    InfoWindow
} from 'react-google-maps';
import './BusTracking.scss';

const MyMapComponent = compose(
    withProps({
        googleMapURL:
            'https://maps.googleapis.com/maps/api/js?key=AIzaSyCfKzWSxw5KYzbBwuEC9wQGqTQItPEdcUQ&v=3.exp&libraries=geometry,drawing,places',
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `68vh` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withStateHandlers(
        () => ({
            isOpen: true,
            isOpenBus: true
            // isOpenParent: true
        }),
        {
            onToggleOpen:
                ({ isOpen }) =>
                () => ({
                    isOpen: !isOpen
                }),
            onToggleOpenBus:
                ({ isOpenBus }) =>
                () => ({
                    isOpenBus: !isOpenBus
                })
            // onToggleOpenParent:
            //     ({ isOpenParent }) =>
            //     () => ({
            //         isOpenParent: !isOpenParent
            //     })
        }
    ),
    withScriptjs,
    withGoogleMap
)((props) => (
    <div>
        <GoogleMap
            zoom={props.zoom}
            center={
                props.center !== undefined
                    ? props.center
                    : props.destination.position
            }
        >
            {props.markers.map((mark) => (
                <Marker
                    key={mark[3]}
                    position={{ lat: mark[1], lng: mark[2] }}
                    onClick={
                        mark[3] === 1
                            ? props.onToggleOpen
                            : props.onToggleOpenBus
                    }
                    icon={props.icons[mark[3] - 1]}
                >
                    {mark[3] === 1
                        ? props.isOpen && (
                              <InfoWindow onCloseClick={props.onToggleOpen}>
                                  <div>
                                      <div>{mark[0]}</div>
                                  </div>
                              </InfoWindow>
                          )
                        : props.isOpenBus && (
                              <InfoWindow onCloseClick={props.onToggleOpenBus}>
                                  <div>{mark[0]}</div>
                              </InfoWindow>
                          )}
                </Marker>
            ))}
            {/* <Marker
                key={props.parent.key}
                position={props.parent.position}
                onClick={props.onToggleOpenParent}
                icon={props.parent.icon}
            >
                {props.isOpenParent && (
                    <InfoWindow onCloseClick={props.onToggleOpenParent}>
                        <div>Parent</div>
                    </InfoWindow>
                )}
            </Marker> */}
        </GoogleMap>
    </div>
));

class BusTracking extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wscount: 0,
            data: { waypoints: [] },
            icons: [
                Methods.global_url + '/travelmate/studentIcon.png',
                Methods.global_url + '/travelmate/busIcon.png'
            ],
            centerposition: [],
            parentposition: [],
            zoom: 13,
            status: true,
            dest: [],
            content: [],
            busstatus: false
        };
    }
    componentDidMount() {
        // this.getParentLocation();
        this.InitialCheck();
        // this.StartTracking();
    }

    async InitialCheck() {
        const rollno = localStorage.getItem('rollno');
        let bnum;
        await fetch(
            `${Methods.global_url}/travelmate/lib/findBusUUID.php?rollno=${rollno}`
        )
            .then((res) => res.text())
            .then((data) => (bnum = data));
        await fetch(
            `${Methods.global_url}/travelmate/findlocation.php?UUID=${bnum}`
        ).then((res) =>
            res.redirected
                ? this.StartTracking()
                : (this.setState({ busstatus: false }),
                  this.setState({ status: false }))
        );
    }

    getParentLocation() {
        // console.log('getParentLocation');
        navigator.geolocation.getCurrentPosition(
            (p) => {
                let lat = p.coords.latitude;
                let lng = p.coords.longitude;
                this.setState({
                    parentposition: {
                        key: 3,
                        position: {
                            lat: lat,
                            lng: lng
                        },
                        icon: './images/parentmarker.png'
                    }
                });
            },
            (error) => console.log('Could not get location'),
            {
                enableHighAccuracy: true
            }
        );
    }

    busClicked() {
        // console.log('busClicked');
        this.setState({
            centerposition: {
                lat: this.state.data.waypoints[1][1],
                lng: this.state.data.waypoints[1][2]
            },
            zoom: 16
        });
    }

    StartTracking() {
        const rollno = localStorage.getItem('rollno');
        var URL = 'www.teleuniv.net.in';
        var wsURL = 'ws://' + URL + ':9002/websockets/testwebsock.php';
        if (this.state.wscount < 1) {
            var ws = new WebSocket(wsURL);
            this.setState({ wscount: 1 });
            ws.onopen = function () {
                try {
                    var userInfo = {
                        mid: 'updateUserInfo',
                        user: { rollno: rollno },
                        role: 'parent'
                    };
                    ws.send(JSON.stringify(userInfo));
                } catch (ex) {
                }
            };
            let c = 0;
            ws.onmessage = function (event) {
                let res = event.data;
                let data = JSON.parse(res);
                if (data.tripstarted === false) {
                    ws.close();
                    this.setState({ wscount: 0 });
                    this.setState({ busstatus: false });
                } else {
                    this.setState({ busstatus: true });
                }
                this.setState({ data: data });
                this.setState({ content: data.waypoints[0][5] });
                this.setState({ status: false });
                if (c === 0) {
                    this.setState({
                        centerposition: {
                            lat:
                                (data.waypoints[0][1] + data.waypoints[1][1]) /
                                2,
                            lng:
                                (data.waypoints[0][2] + data.waypoints[1][2]) /
                                2
                        }
                    });
                    c++;
                }
            }.bind(this);
            ws.onclose = function () {
                console.log('Connection is closed...');
            };
        }
    }
    render() {
        const override = `
            display: block;
            margin: 10% auto;
            border-color: red;
        `;
        if (this.state.status) {
            return (
                <div>
                    <h1 className="mt-4" style={{ textAlign: 'center' }}>
                        Waiting for data ...
                    </h1>
                    <MoonLoader
                        color={'green'}
                        isLoading={true}
                        css={override}
                        size={60}
                    />
                </div>
            );
        }
        return (
            <div className="">
                <div className="">
                    <div className="container">
                        <div
                            className="m-2"
                            style={{ fontSize: '20px', display: 'flex' }}
                        >
                            <div className="mr-4">
                                <a
                                    href={RemoveLastDirectoryPartOf(
                                        window.location.href
                                    )}
                                    style={{ textDecoration: 'none' }}
                                >
                                    <i className="fe fe-arrow-left" />
                                </a>
                            </div>
                            <div>Bus Tracking</div>
                        </div>
                    </div>
                    <div>
                        {this.state.busstatus === false ? (
                            <div className="container">
                                <Card className="mt-4 p-4 text-center">
                                    Bus not available
                                    <div
                                        onClick={() => {
                                            this.StartTracking();
                                        }}
                                    >
                                        <i className="fe fe-refresh-ccw"></i>
                                    </div>
                                </Card>
                            </div>
                        ) : (
                            <div style={{ position: 'relative' }}>
                                <div className="buscontrol">
                                    <button
                                        className="clickicon btn btn-success"
                                        onClick={() => this.busClicked()}
                                    >
                                        <FontAwesomeIcon
                                            icon={faBus}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </button>
                                </div>
                                <MyMapComponent
                                    center={this.state.centerposition}
                                    markers={this.state.data.waypoints}
                                    parent={this.state.parentposition}
                                    zoom={this.state.zoom}
                                    icons={this.state.icons}
                                />
                                <div
                                    style={{
                                        textAlign: 'center',
                                        color: 'white',
                                        background:
                                            'purple none repeat scroll 0% 0% ',
                                        margin: '0px',
                                        padding: '10px'
                                    }}
                                >
                                    <b>
                                        <span>
                                            R{this.state.data.routeid} -{' '}
                                            {this.state.content.previousstop} ⇌{' '}
                                            {this.state.content.nextstop}
                                        </span>
                                        <div>
                                            {this.state.content.arrivaltime}
                                        </div>
                                    </b>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default BusTracking;
